import Vue from 'vue'
import App from '../layout/layout/index.vue'
import store from '../public/store'
import router from './router'
import ElementUi from 'element-ui'
import KyeUi from '../public/components'
import errorHandle from '../public/utils/error-handler'
import './store'
import './layout/setup'
import DomHint from './plugins/dom-hint'

Vue.use(ElementUi, { size: 'mini' })
Vue.use(KyeUi)
Vue.use(errorHandle)

if (process.env.NODE_ENV === 'development') {
  Vue.use(DomHint)
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  render: (h) => h('App')
})



// WEBPACK FOOTER //
// ./src/layout/main.js